import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from 'signup-constants/Step';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { getLandingPageButton } from './getLandingPageText';
import { useLandingPage } from './useLandingPage';
import { Text } from 'foundations-components/components/Text';
import { useWorkEmailLabel } from './useWorkEmailLabel';
import { LayoutType } from 'signup-components/types';
import { SidePanelLandingPageView } from './acq172/SidePanelLandingPageView';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService,
    shouldShowSignInButton,
    emailSignupEnabled
  } = getFlowConfig();
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  useExperiment(ExperimentKeys.ACQ0170, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0173, TrackWhen.enrolled);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ172VariantC
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.enrolled);
  const {
    labelOverride
  } = useWorkEmailLabel();
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const Footer = () => {
    if (isInstanceOfSignupEmbedder) {
      return /*#__PURE__*/_jsxs(Text, {
        as: "div",
        marginBlock: "600",
        textAlign: "center",
        typography: "body-100",
        children: [shouldShowSignInButton && /*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
      });
    }
    if (isTrellisThemeEnabled) {
      return /*#__PURE__*/_jsxs(View, {
        marginInline: "auto",
        maxInlineSize: "420px",
        paddingInline: "400",
        textAlign: "left",
        children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };
  if (layoutType === LayoutType.SidePanel && !isAssignedToACQ172VariantC(ExperimentParameterGroup.Variant_C)) {
    return /*#__PURE__*/_jsx(SidePanelLandingPageView, {});
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [/*#__PURE__*/_jsx(LandingPageTitle, {
          isMobile: isMobile
        }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
          $layoutType: layoutType,
          $shouldRestrictWidth: true,
          children: [/*#__PURE__*/_jsx(OAuthSignupSection, {
            shouldShowSeperator: emailSignupEnabled
          }), emailSignupEnabled && !isTrellisThemeEnabled && /*#__PURE__*/_jsx(SignupDataInputForm, {
            autoFocus: false,
            buttonProps: {
              label: getLandingPageButton()
            },
            dataKey: Data.Email,
            inputMode: 'email',
            labelOverride: labelOverride,
            shouldTrimData: true,
            submit: chooseEmailSignUp
          }, Data.Email), emailSignupEnabled && isTrellisThemeEnabled && /*#__PURE__*/_jsx(View, {
            marginInline: "auto",
            maxInlineSize: "420px",
            paddingInline: "400",
            children: /*#__PURE__*/_jsx(SignupDataInputForm, {
              autoFocus: false,
              buttonProps: {
                label: getLandingPageButton()
              },
              dataKey: Data.Email,
              inputMode: 'email',
              labelOverride: labelOverride,
              shouldTrimData: true,
              submit: chooseEmailSignUp
            }, Data.Email)
          }), /*#__PURE__*/_jsx(Footer, {})]
        })]
      })
    })
  });
};
export default LandingPageView;